"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bodyParse = void 0;
function bodyParse(response) {
    var _a;
    if (response.responseBody && ((_a = response.responseHeaders.get('Content-Type')) === null || _a === void 0 ? void 0 : _a.indexOf('application/json')) !== -1) {
        return JSON.parse(response.responseBody);
    }
    return response.responseBody;
}
exports.bodyParse = bodyParse;
//# sourceMappingURL=bodyParser.js.map